import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import "./UpdateStockQuantityModal.scss";

const UpdateStockQuantityModal = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [createLowStock, setCreateLowStock] = useState(true); // Default to 'Create Low Stock Planning'
  const [addUnknown, setAddUnknown] = useState(false);
  const { onSave, scannedlist, unknownlist } = props;
  console.log("unknownlist", unknownlist);
  const lowStockItems = scannedlist.filter((item) => item.total_order_qty > 0);
  const lowStockCount = lowStockItems.length;
  useImperativeHandle(ref, () => ({
    openModal: () => setShow(true),
    closeModal: () => setShow(false),
  }));

  const handleCloseModal = () => {
    setShow(false);
  };

  const handleSave = () => {
    if (onSave) {
      onSave(createLowStock, addUnknown);
    }
    setShow(false);
  };

  const renderUnknownModal = () => {
    if (unknownlist.length === 0) {
      return null;
    }
    return (
      <div>
        <p className="confirmation-message-stock-scan">
          {t("Do you want to save Unknown Items?")}
        </p>
        <div className="flexbox-update-quantity-modal">
          {/* Radio Button Options */}
          <div className="form-check">
            <input
              type="radio"
              id="addUnknown"
              name="addUnknown"
              value="addUnknown"
              checked={addUnknown}
              onChange={() => setAddUnknown(true)}
              className="form-check-input"
            />

            <label htmlFor="addUnknown" className="form-check-label">
              {t("Yes")}
            </label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              id="noAddUnknown"
              name="addUnknown"
              value="noAddUnknown"
              checked={!addUnknown}
              onChange={() => setAddUnknown(false)}
              className="form-check-input"
            />
            <label htmlFor="noAddUnknown" className="form-check-label">
              {t("No")}
            </label>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`new-update-quantity-modal modal fade ${show ? "show d-block" : "d-none"}`}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="updateStockQuantityModal"
      aria-hidden={!show}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          {/* Modal Header */}
          <div className="modal-header border-0">
            <h5 className="modal-title">
              {lowStockCount > 0
                ? t("Update Stock Take Quantity")
                : t("Create Stock Take")}
            </h5>
          </div>

          {/* Modal Body */}
          <div className="modal-body">
            {lowStockCount > 0 ? (
              <>
                <div>
                  <p className="confirmation-message-stock-scan">
                    {t("Do you want to create Low Stock Planning?")}
                  </p>
                  <div className="flexbox-update-quantity-modal">
                    {/* Radio Button Options */}
                    <div className="form-check">
                      <input
                        type="radio"
                        id="createLowStock"
                        name="lowStockPlanning"
                        value="create"
                        checked={createLowStock}
                        onChange={() => setCreateLowStock(true)}
                        className="form-check-input"
                      />

                      <label
                        htmlFor="createLowStock"
                        className="form-check-label"
                      >
                        {t("Create Low Stock Planning")}
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        type="radio"
                        id="notNow"
                        name="lowStockPlanning"
                        value="notNow"
                        checked={!createLowStock}
                        onChange={() => setCreateLowStock(false)}
                        className="form-check-input"
                      />
                      <label htmlFor="notNow" className="form-check-label">
                        {t("Not now")}
                      </label>
                    </div>
                  </div>
                  {createLowStock ? (
                    <div className="placeholder-up-input w-100 form-floating mb-4">
                      <input
                        type="text"
                        readOnly={true}
                        value={lowStockCount}
                        id="update-stock-qty-scan"
                        className="placeholder-up-input-field form-control fs-6 px-3 stock-take-inner-row-col-mid-header-left-search-input "
                      />
                      <label
                        className="placeholder-up-input-label fs-6"
                        htmlFor="update-stock-qty-scan"
                      >
                        SKU*
                      </label>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {renderUnknownModal()}
              </>
            ) : (
              <>
                <p className="text-muted">
                  {t("Are you creating Stock Take?")}
                </p>
                {renderUnknownModal()}
              </>
            )}
          </div>

          {/* Modal Footer */}
          <div className="modal-footer border-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleCloseModal}
            >
              {t("Cancel")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSave}
            >
              {lowStockCount > 0 || unknownlist.length > 0
                ? t("Save")
                : t("Confirm")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default UpdateStockQuantityModal;
